import {DataTableColumn} from "mantine-datatable";
import {Invoice} from "../types.ts";
import {Text} from '@mantine/core';

export const useTableColumns = (context: 'customer' | 'reports' = 'reports', onRecordClick?: (record: Invoice) => void) => {

    const columns: DataTableColumn<Invoice>[] = [
        {
            accessor: 'id',
            title: 'Invoice ID',
            render: (record: Invoice) => (
                <Text
                    c="blue"
                    style={{cursor: 'pointer'}}
                    onClick={() => onRecordClick?.(record)}
                >
                    {record.id}
                </Text>
            )
        },
        ...(context === 'reports' ? [{
            accessor: 'customer',
            title: 'Customer',
            render: (record: Invoice) => (
                <Text c="blue" style={{cursor: 'pointer'}}>
                    {record.customer ? record.customer.name : record.customerId}
                </Text>
            )
        }] : []),
        {
            accessor: 'created',
            title: 'Created',
            render: (record: Invoice) => (
                <Text size="sm">
                    {record.created ? new Date(record.created).toLocaleDateString() : '-'}
                </Text>
            )
        },
    ];

    return {
        columns,
    }
}
